// extracted by mini-css-extract-plugin
export default {"container":"jobApplyCard_container__1ZCPC","leftContainer":"jobApplyCard_leftContainer__OZJtJ","rightContainer":"jobApplyCard_rightContainer__-kU6m"};